import React from 'react';
import { connect } from 'react-redux';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

import UserService from 'shared/services/UserService';
import { me } from 'shared/actions/userActions';
import Animation from 'shared/components/Animation';
import PullRelease from 'shared/components/PullRelease';
import messages, { FormattedMessage } from 'shared/messages/messages';
import config from 'shared/config/config';

const PWA_ORIGIN = 1; // portal origin would be 0

const LOGIN_MESSAGE = <FormattedMessage {...messages.consumer_login_message} />
const FORGOT_PASSWORD_MESSAGE = <FormattedMessage {...messages.consumer_forgot_password} />
const UPDATE_PASSWORD_MESSAGE = <FormattedMessage {...messages.consumer_update_password} />;
const UPDATE_EMAIL_MESSAGE = <FormattedMessage {...messages.consumer_update_email} />;
const LINK_EXPIRED_MESSAGE = <FormattedMessage {...messages.consumer_link_expired} />;

const LOGIN_VIEW = 0,
  FORGOT_PASSWORD_VIEW = 1,
  UPDATE_PASSWORD_VIEW = 2;

const ANIMATION_PROPS = {
  spring: {
    from: { marginTop: '-2rem', opacity: 0 },
    to: { marginTop: '0rem', opacity: 1 }
  }
}

const defaultFlags = {
  error: false,
  emailError: false,
  passwordError: false
}

let userService = new UserService();

const styles = theme => ({
  main: {
    background: config.pwa_home_bg_color + ' !important',
  },
  welcome: {
    fontFamily: config.main_font + ' !important',
    color: config.pwa_default_font_color + ' !important'
  },
  text: {
    color: config.pwa_default_font_color + ' !important'
  },
  loginbutton: {
    background: config.pwa_default_button_bg_color + ' !important',
    color: config.pwa_default_button_font_color + ' !important'
  },
  terms: {
    color: config.pwa_default_font_color + ' !important'
  },
  inputText: {
    fontFamily: config.sub_font + ' !important'
  },
  sideHeader: {
    background: config.pwa_login_sideheader_bg_color + ' !important',
    color: config.pwa_default_font_color + ' !important',
    height: '100%'
  },
  loginBackGround: {
    background: config.pwa_home_bg_color + ' !important',
  },
  brand: {
    display: 'block',
    margin: '0 auto',
    marginTop: '50%',
    height: config.pwa_login_logo_height,
  },
  btnPrimary: {
    display: 'inline-block',
    marginTop: '1.875rem',
    border: '0.0625rem solid #bbb',
    fontFamily: config.main_font,
    borderRadius: '3.125rem',
    fontSize: '0.875rem',
    fontWeight: '700',
    lineHeight: '1.5rem',
    textAlign: 'center',
    letterSpacing: '0.15em',
    textTransform: 'uppercase',
    background: config.pwa_default_button_bg_color + ' !important',
    color: config.pwa_default_button_font_color,
    padding: '1.125rem',
    cursor: 'pointer',
    opacity: '1'
  },
  btnSecondary: {
    display: 'inline-block',
    marginTop: '1.875rem',
    border: '0.0625rem solid #bbb',
    fontFamily: config.main_font,
    borderRadius: '3.125rem',
    fontSize: '0.875rem',
    fontWeight: '700',
    lineHeight: '1.5rem',
    textAlign: 'center',
    letterSpacing: '0.15em',
    textTransform: 'uppercase',
    background: config.pwa_home_bg_color + ' !important',
    color: config.pwa_navbar_font_color,
    padding: '1.125rem',
    cursor: 'pointer',
    opacity: '1',
    '&:hover': {
      color: 'config.pwa_default_button_bg_color' + ' !important',
      borderColor: 'config.pwa_default_button_bg_color' + ' !important',
    }
  },
  btnForgot: {
    position: 'absolute',
    top: '2.25rem',
    right: '0.4375rem',
    background: config.pwa_login_forgot_btn_bg_color,
    color: config.pwa_login_forgot_btn_font_color,
    border: 'none',
    borderRadius: '5px',
    fontFamily: config.sub_font,
    fontSize: '1.125rem',
    fontWeight: 'normal',
    padding: '0.55rem 1.25rem',
    cursor: 'pointer',
    '&:hover': {
      background: '#d1d6ef'
    }
  }
});

class Login extends React.Component {


  constructor(props) {
    super(props);

    let view, message, error = false;
    if (props.resetTokenExpired) {
      view = FORGOT_PASSWORD_VIEW;
      message = LINK_EXPIRED_MESSAGE;
      error = true;

    } else if (props.updatePassword) {
      view = UPDATE_PASSWORD_VIEW;
      message = UPDATE_PASSWORD_MESSAGE; // might change, see getSession

    } else {
      view = LOGIN_VIEW;
      message = LOGIN_MESSAGE;
    }

    this.state = {
      email: '',
      password: '',
      passwordConfirmation: '',
      loggedIn: false,
      loading: true,
      submitting: false,
      error,
      emailError: false,
      passwordError: false,
      passwordConfirmationError: false,
      message,
      view,
      requesting: false,
      passwordRequested: false,
      updating: false,
      updatePassword: !!this.props.updatePassword
    }
  }

  componentDidMount() {
    this.getSession();
  }

  async getSession() {
    let user = this.props.user || await this.props.me();

    if (user) {
      if (this.state.updatePassword) {
        this.setState({
          loading: false,
          message: this.getUpdatePasswordMessage()
        });

      } else {
        this.setState({
          email: user.email,
          name: user.name,
          loggedIn: true,
          loading: false
        });
      }
    } else {
      this.setState({
        loading: false
      });
    }
  }

  getUpdatePasswordMessage() {
    if (this.props.user.fake_email) {
      return UPDATE_EMAIL_MESSAGE;
    } else {
      return UPDATE_PASSWORD_MESSAGE;
    }
  }

  showLogin(event) {
    event.preventDefault();

    this.setState({
      view: LOGIN_VIEW,
      message: LOGIN_MESSAGE
    });
  }

  showForgotPassword(event) {
    event.preventDefault();

    this.setState({
      view: FORGOT_PASSWORD_VIEW,
      message: FORGOT_PASSWORD_MESSAGE,
      passwordRequested: false
    });
  }

  showUpdatePassword(event) {
    event.preventDefault();

    this.setState({
      view: UPDATE_PASSWORD_VIEW,
      message: this.getUpdatePasswordMessage(),
      password: '',
      passwordConfirmation: ''
    });
  }

  login = event => {
    event.preventDefault();

    let missingEmail = !this.state.email;
    let missingPassword = !this.state.email;
    let error = missingEmail || missingPassword;

    if (error) {
      this.setState({
        emailError: missingEmail,
        passwordError: missingPassword,
        error: error,
        message: <FormattedMessage {...messages.consumer_missing_something_error} />
      });
    } else {
      this.setState({
        submitting: true,
        error: false,
        message: LOGIN_MESSAGE
      });

      userService.signInWithCredentials(this.state.email, this.state.password)
        .then(() => this.setState(() => ({
          submitting: false,
          loggedIn: true
        })))
        .catch(error => {
          this.setState({ message: error, error: true, submitting: false, loggedIn: false })
        });
    }
  }

  requestPasswordReset = event => {
    event.preventDefault();

    let email = null;
    if (this.state.email.match(/@/)) {
      email = this.state.email;
    }

    let phone = null;
    if (!email) {
      phone = this.parsePhone(this.state.email);
    }

    if (!email && !phone) {
      let message = <FormattedMessage {...messages.consumer_enter_valid_email_phone} />;

      this.setState({
        error: true,
        emailError: true,
        message
      });
      return;
    }

    this.setState({ requesting: true });

    let params = {
      origin: PWA_ORIGIN,
      email: phone || email
    };
    userService.requestPasswordReset(params)
      .then(resp => {
        this.setState({
          requesting: false,
          passwordRequested: true,
          message: resp.msg,
          error: false,
          emailError: false
        });
      })
      .catch(err => {
        this.setState({
          requesting: false,
          error: true,
          emailError: false,
          message: err.error || err
        });
      });
  }

  parsePhone(value) {
    let phone = null;

    if (!value.match(/[^\d\+\ \-]/)) {
      phone = value;
    }

    return phone;
  }

  updatePassword = event => {
    event.preventDefault();

    const { user } = this.props;
    let { email, password, passwordConfirmation } = this.state;

    let message,
      error = false,
      emailError = false,
      passwordError = false,
      passwordConfirmationError = false;

    if (user.fake_email && !email) {
      error = true;
      emailError = true;
      message = <FormattedMessage {...messages.consumer_enter_email} />;

    } else if (!password) {
      error = true;
      passwordError = true;
      passwordConfirmationError = !passwordConfirmation;
      message = <FormattedMessage {...messages.consumer_enter_password} />;

    } else if (!passwordConfirmation) {
      error = true;
      passwordConfirmationError = true;
      message = <FormattedMessage {...messages.consumer_confirm_password} />;

    } else if (password !== passwordConfirmation) {
      error = true;
      passwordError = true;
      passwordConfirmationError = true;
      message = <FormattedMessage {...messages.consumer_passwords_dont_match} />;

    } else if (password.length < 6) {
      error = true;
      passwordError = true;
      passwordConfirmationError = true;
      message = <FormattedMessage values={{ count: 6 }} {...messages.consumer_password_alteast_length} />;
    }

    if (error) {
      this.setState({
        error,
        passwordError,
        passwordConfirmationError,
        message
      });
      return;
    }

    const params = {
      email: user.fake_email ? email : null,
      new_password: password,
      password_confirmation: passwordConfirmation
    }
    userService.updatePassword(params)
      .then(() => {
        this.setState({
          loggedIn: true,
          updatePassword: false
        });
      })
      .catch(err => {
        this.setState({
          error: true,
          message: err.error
        });
      });
  }

  emailChange = event => {
    this.setState({
      ...defaultFlags,
      email: event.target.value,
      message: LOGIN_MESSAGE
    });
  }

  passwordChange = event => {
    this.setState({
      ...defaultFlags,
      password: event.target.value,
      message: LOGIN_MESSAGE
    });
  }

  forgotEmailChange = event => {
    this.setState({
      ...defaultFlags,
      email: event.target.value,
      message: FORGOT_PASSWORD_MESSAGE
    });
  }

  updateEmailChange = event => {
    this.setState({
      ...defaultFlags,
      email: event.target.value,
      message: this.getUpdatePasswordMessage()
    });
  }

  updatePasswordChange = event => {
    this.setState({
      ...defaultFlags,
      password: event.target.value,
      message: this.getUpdatePasswordMessage()
    });
  }

  passwordConfirmationChange = event => {
    this.setState({
      ...defaultFlags,
      passwordConfirmation: event.target.value,
      message: this.getUpdatePasswordMessage()
    });
  }

  renderLogin() {
    const { classes, theme, match } = this.props;
    return (
      <Animation props={ANIMATION_PROPS}>
        <div id="welcome" className={classes.main}>
          <div className={classes.sideHeader + ' left-col'}>
            <img className={classes.brand} src={config.pwa_login_logo} />
          </div>

          <div className={classes.loginBackGround + " right-col"}>
            <Form className="login-form" onSubmit={this.login}>
              <PullRelease>
                <img className="logo" src={config.pwa_login_mini_logo} />
              </PullRelease>
              <h1 className={classes.welcome}><FormattedMessage {...messages.consumer_welcome_back} /></h1>
              <h2 className={this.state.error ? 'error' : classes.text}>{this.state.message}</h2>
              <Form.Group>
                <Form.Label className={classes.text} for="email"><FormattedMessage {...messages.consumer_email_placeholder} /></Form.Label>
                <FormattedMessage {...messages.consumer_email_placeholder}>
                  {
                    (msg) =>
                      <input className={this.state.emailError ? 'error' : classes.inputText}
                        type="email"
                        name="email"
                        placeholder={msg}
                        value={this.state.email}
                        onChange={this.emailChange}
                      />
                  }
                </FormattedMessage>
              </Form.Group>
              <Form.Group>
                <Form.Label className={classes.text} for="password"><FormattedMessage {...messages.consumer_password_placeholder} /></Form.Label>
                <FormattedMessage {...messages.consumer_password_placeholder}>
                  {
                    (msg) =>
                      <input className={this.state.passwordError ? 'error' : classes.inputText}
                        type="password"
                        name="password"
                        placeholder={msg}
                        value={this.state.password}
                        onChange={this.passwordChange}
                      />
                  }
                </FormattedMessage>
                <button type="button" className={classes.btnForgot} onClick={e => this.showForgotPassword(e)}>
                  <FormattedMessage {...messages.button_forgot} />
                </button>
              </Form.Group>
              <Button variant="primary" className={classes.btnPrimary + " bs-btn full-width"} type="submit">
                <span>{this.state.submitting ?
                  <FormattedMessage {...messages.consumer_logging_in} /> :
                  <FormattedMessage {...messages.button_login} />
                }
                </span>
              </Button>
              <p className={classes.terms}>
                <FormattedMessage {...messages.consumer_agreement} />
                <a href="https://capturelife.com/terms" target="_blank">
                  <FormattedMessage {...messages.consumer_terms_of_use} />
                </a>.</p>
            </Form>
          </div>
        </div>
      </Animation >
    )
  }

  renderForgotPassword() {
    const { classes, theme, match } = this.props;

    let form = null;
    if (!this.state.passwordRequested) {
      form = (
        <div>
          <Form.Group>
            <Form.Label for="email" className={classes.text}><FormattedMessage {...messages.consumer_email_or_phone} /></Form.Label>
            <FormattedMessage {...messages.consumer_email_or_phone}>
              {
                (msg) =>
                  <input className={this.state.emailError ? 'error' : classes.inputText}
                    type="text"
                    name="email"
                    placeholder={msg}
                    value={this.state.email}
                    onChange={this.forgotEmailChange}
                  />
              }
            </FormattedMessage>
          </Form.Group>
          <Button variant="primary" className={classes.btnPrimary + " bs-btn full-width"} type="submit">
            <span>{this.state.requesting ? 'Resetting password...' : 'Reset Password'}</span>
          </Button>
        </div>
      );
    }

    let messageStyle = null;
    if (!form) {
      messageStyle = {
        margin: '2rem 0 1rem'
      };
    }

    return (
      <Animation props={ANIMATION_PROPS}>
        <div id="welcome" className={classes.main}>
          <div className={classes.sideHeader + ' left-col'}>
            <img className={classes.brand} src={config.pwa_login_logo} />
          </div>

          <div className={classes.loginBackGround + " right-col"}>
            <Form className="login-form" onSubmit={this.requestPasswordReset}>
              <PullRelease>
                <img className="logo" src={config.pwa_login_mini_logo} />
              </PullRelease>
              <h1 className={classes.welcome}><FormattedMessage {...messages.consumer_forgot_your_password} /></h1>
              <h2 className={this.state.error ? 'error' : classes.text}>{this.state.message}</h2>
              {form}
              <Button className={classes.btnSecondary + " bs-btn full-width"} type="button" onClick={e => this.showLogin(e)}>
                <span><FormattedMessage {...messages.button_back_to_login} /></span>
              </Button>
            </Form>
          </div>
        </div>
      </Animation>
    )
  }

  renderUpdatePassword() {
    let email = null;
    if (this.props.user.fake_email) {
      email = (
        <Form.Group>
          <Form.Label className={classes.text} for="email"><FormattedMessage {...messages.consumer_email_placeholder} /></Form.Label>
          <FormattedMessage {...messages.consumer_email_placeholder}>
            {
              (msg) =>
                <input className={this.state.emailError ? 'error' : classes.inputText}
                  type="email"
                  name="email"
                  placeholder={msg}
                  value={this.state.email}
                  onChange={this.updateEmailChange}
                />
            }
          </FormattedMessage>
        </Form.Group>
      );
    }

    const { classes, theme, match } = this.props;

    return (
      <Animation props={ANIMATION_PROPS}>
        <div id="welcome" className={classes.main}>
          <div className={classes.sideHeader + ' left-col'}>
            <img className={classes.brand} src={config.pwa_login_logo} />
          </div>

          <div className={classes.loginBackGround + " right-col"}>
            <Form className="login-form" onSubmit={this.updatePassword}>
              <PullRelease>
                <img className="logo" src={config.pwa_login_mini_logo} />
              </PullRelease>
              <h1 className={classes.welcome}><FormattedMessage {...messages.consumer_update_your_password} /></h1>
              <h2 className={this.state.error ? 'error' : classes.text}>{this.state.message}</h2>
              {email}
              <Form.Group>
                <Form.Label className={classes.text} for="password"><FormattedMessage {...messages.consumer_password_placeholder} /></Form.Label>
                <FormattedMessage {...messages.consumer_password_placeholder}>
                  {
                    (msg) =>
                      <input className={this.state.passwordError ? 'error' : classes.inputText}
                        type="password"
                        name="password"
                        placeholder={msg}
                        value={this.state.password}
                        onChange={this.updatePasswordChange}
                      />
                  }
                </FormattedMessage>
              </Form.Group>
              <Form.Group>
                <Form.Label className={classes.text} for="password_confirmation"><FormattedMessage {...messages.consumer_confirm_your_password} /></Form.Label>
                <FormattedMessage {...messages.consumer_update_password}>
                  {
                    (msg) =>
                      <input className={this.state.passwordConfirmationError ? 'error' : classes.inputText}
                        type="password"
                        name="password_confirmation"
                        placeholder={msg}
                        value={this.state.passwordConfirmation}
                        onChange={this.passwordConfirmationChange}
                      />
                  }
                </FormattedMessage>
              </Form.Group>
              <Button variant="primary" className={classes.btnPrimary + " bs-btn full-width"} type="submit">
                <span>{this.state.updating ?
                  <FormattedMessage {...messages.consumer_updating_password} />
                  : <FormattedMessage {...messages.consumer_update_password} />}</span>
              </Button>
              <Button className={classes.btnSecondary + " bs-btn full-width"} type="button" onClick={e => this.showLogin(e)}>
                <span><FormattedMessage {...messages.button_cancel} /></span>
              </Button>
            </Form>
          </div>
        </div>
      </Animation>
    )
  }

  render() {

    if (this.state.loading) {
      return null;
    }

    if (this.state.loggedIn) {
      return (<Redirect to="/" />);
    }


    switch (this.state.view) {
      case LOGIN_VIEW:
        return this.renderLogin();

      case FORGOT_PASSWORD_VIEW:
        return this.renderForgotPassword();

      case UPDATE_PASSWORD_VIEW:
        return this.renderUpdatePassword();
    }
  }
}

const mapStateToProps = state => ({
  user: state.userReducer.user
});

export default connect(mapStateToProps, { me })(withStyles(styles, { withTheme: true })(Login));
